<div class="app-page">
  <div class="app-page-header">
    <div>
      <h1 class="app-page-title">Patient Registration</h1>
      <p class="app-page-subtitle">Create or update patient registration details.</p>
    </div>
  </div>

  <div class="app-panel app-panel-form">
    <div class="app-panel-body">
      <form [formGroup]="pRegisterForm" (ngSubmit)="onRegister()">
        <div class="patient-benefit-selector">
          <mat-form-field appearance="outline" class="benefit-type-field">
            <mat-label>Patient Benefit Type</mat-label>
            <mat-select formControlName="benefitType" (selectionChange)="onBenefitTypeChange($event.value)">
              <mat-option value="DENTAL">Dental</mat-option>
              <mat-option value="MEDICAL">Medical</mat-option>
              <mat-option value="BOTH">Both (Dental + Medical)</mat-option>
            </mat-select>
          </mat-form-field>
          <span class="patient-benefit-help">Select the type of insurance to register. Both keeps separate Dental and Medical insurance information.</span>
        </div>

        <div class="app-form-grid">

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName" minlength="1" title="Name at least has 3 characters !">
              <mat-error *ngIf="pRegisterForm.controls.firstName.errors?.required">
                This field is required !
              </mat-error>
              <mat-error *ngIf="pRegisterForm.controls.firstName?.value">
                Name at least has 3 characters !
              </mat-error>
            </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="lastName">
              <mat-error *ngIf="pRegisterForm.controls.lastName.errors?.required">
                This field is required !
              </mat-error>
            </mat-form-field>
          </div>

          <div class="app-form-col" *ngIf="includesDental">
              <mat-form-field
                  appearance="outline"
                  class="app-full-width payer-field">

                  <mat-label>Carrier Name</mat-label>

                  <input
                      matInput
                      type="text"
                      placeholder="Search carrier name or payer ID"
                      [matAutocomplete]="payerAuto"
                      [formControl]="payerSearchControl"
                      (focus)="onPayerSearchFocus()">

                  <button
                      *ngIf="payerSearchControl.value"
                      mat-icon-button
                      matSuffix
                      type="button"
                      class="payer-clear-btn"
                      aria-label="Clear carrier"
                      (click)="clearPayerSelection(); $event.stopPropagation()">

                      <mat-icon>close</mat-icon>
                  </button>

                  <mat-autocomplete
                      #payerAuto="matAutocomplete"
                      [displayWith]="displayPayer"
                      (optionSelected)="onPayerSelected($event.option.value)">

                      <mat-option
                          *ngIf="payerSearchLoading"
                          disabled>

                          <span class="spinner-border spinner-border-sm mr-2"></span>
                          Loading carriers...

                      </mat-option>

                      <mat-option
                          *ngFor="let payer of filteredPayers; trackBy: trackByFn"
                          [value]="payer">

                          <div class="payer-option">
                              <div class="payer-option-main">
                                  {{ payer.name }}
                              </div>

                              <div
                                  *ngIf="payer.payerIdCode"
                                  class="payer-option-code">

                                  Payer ID: {{ payer.payerIdCode }}

                              </div>
                          </div>

                      </mat-option>

                      <mat-option
                          *ngIf="
                              !payerSearchLoading &&
                              payerSearchControl.value &&
                              filteredPayers.length === 0
                          "
                          disabled>
                          No matching carrier found
                      </mat-option>

                  </mat-autocomplete>

                  <mat-hint
                      *ngIf="selectedPayer?.payerIdCode"
                      class="payer-selected-hint">
                      Payer ID: {{ selectedPayer.payerIdCode }}
                  </mat-hint>

                  <mat-error
                      *ngIf="
                          pRegisterForm.get('payer')?.touched &&
                          pRegisterForm.get('payer')?.hasError('required')
                      ">
                      This field is required!
                  </mat-error>

              </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>DOB</mat-label>
              <input matInput [max]="today" [matDatepicker]="picker" formControlName="dob" placeholder="MM/DD/YYYY">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="pRegisterForm.controls.dob.errors?.required">
                This field is required !
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="!isExternalUser" class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email">
              <mat-error *ngIf="pRegisterForm.controls.email.errors?.required">
                This field is required !
              </mat-error>
              <mat-error *ngIf="pRegisterForm.controls.email.errors?.email">
                Require valid email format !
              </mat-error>
            </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Appointment Date</mat-label>
              <input matInput [matDatepicker]="picker1" formControlName="appointmentDate" placeholder="MM/DD/YYYY">
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              <mat-error *ngIf="pRegisterForm.controls['appointmentDate'].hasError('required')">
                This field is required!
              </mat-error>
            </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Appointment Time</mat-label>
              <input class="custom-time-picker" type="time" matInput name="week" min="09:00" max="18:00" formControlName="appointmentTime"/>
              <mat-error *ngIf="pRegisterForm.controls.appointmentTime.errors?.required">
                This field is required !
              </mat-error>
            </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Gender</mat-label>
              <mat-select formControlName="gender">
                <mat-option value="Male">Male</mat-option>
                <mat-option value="Female">Female</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div *ngIf="!isExternalUser" class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Address</mat-label>
              <input matInput formControlName="firstLine" placeholder="First Line">
              <mat-error *ngIf="pRegisterForm.controls.firstLine.errors?.required">
                This field is required !
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="!isExternalUser" class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Second Line</mat-label>
              <input matInput formControlName="secondLine" placeholder="Second Line">
            </mat-form-field>
          </div>

          <div *ngIf="!isExternalUser" class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>City</mat-label>
              <input matInput formControlName="city">
              <mat-error *ngIf="pRegisterForm.controls.city.errors?.required">
                This field is required !
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="!isExternalUser" class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>State</mat-label>
              <mat-select formControlName="state">
                <mat-option *ngFor="let type of stateList" [value]="type.value">{{type.label}}</mat-option>
              </mat-select>
              <mat-error *ngIf="pRegisterForm.controls.state.errors?.required">
                This field is required !
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="!isExternalUser" class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Zip</mat-label>
              <input matInput formControlName="zip" pmZipCode>
              <mat-error *ngIf="pRegisterForm.controls.zip.errors?.required">
                This field is required !
              </mat-error>
              <mat-error *ngIf="pRegisterForm.controls.zip.errors?.pattern">
                Please enter valid format.
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="!isExternalUser" class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Number</mat-label>
              <input matInput formControlName="number" type="tel" pmPhoneFormat>
              <mat-error *ngIf="pRegisterForm.controls.number.errors?.required">
                This field is required !
              </mat-error>
              <mat-error *ngIf="pRegisterForm.controls.number.errors?.pattern">
                Invalid format! Use 555-123-4567
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="!isExternalUser" class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Phone Type</mat-label>
              <mat-select formControlName="phoneType">
                <mat-option *ngFor="let phone of phoneType" [value]="phone.value">{{phone.viewValue}}</mat-option>
              </mat-select>
              <mat-error *ngIf="pRegisterForm.controls.phoneType.errors?.required">
                This field is required !
              </mat-error>
            </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>SSN</mat-label>
              <input matInput formControlName="ssn" type="tel" pmSsnFormat>
              <mat-error *ngIf="pRegisterForm.controls.ssn.errors?.required">
                This field is required !
              </mat-error>
              <mat-error *ngIf="pRegisterForm.controls.ssn.errors?.pattern">
                Invalid format! Use 555-12-4567
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="includesDental" class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Insurance Type</mat-label>
              <mat-select formControlName="insuranceType">
                <mat-option *ngFor="let items of iTypeArray" [value]="items.value">{{items.viewValue}}</mat-option>
              </mat-select>
              <mat-error *ngIf="pRegisterForm.controls.insuranceType.errors?.required">
                This field is required !
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="includesDental" class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Insurance Phone No</mat-label>
              <input matInput formControlName="insurancePhoneNo" type="tel" pmPhoneFormat>
              <mat-error *ngIf="pRegisterForm.controls.insurancePhoneNo.errors?.required">
                This field is required !
              </mat-error>
              <mat-error *ngIf="pRegisterForm.controls.insurancePhoneNo.errors?.pattern">
                Invalid format! Use 555-123-4567
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="!isExternalUser && includesDental" class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Group Name</mat-label>
              <input matInput formControlName="groupName">
            </mat-form-field>
          </div>

          <div *ngIf="!isExternalUser && includesDental" class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Group No</mat-label>
              <input matInput formControlName="groupNo">
            </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>MemberId</mat-label>
              <input matInput formControlName="memberId">
            </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Relationship</mat-label>
              <mat-select formControlName="relationship">
                <mat-option *ngFor="let items of relationshipArray" [value]="items.value">{{items.viewValue}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Provider Name</mat-label>
              <mat-select formControlName="providerId">
                <mat-option *ngFor="let items of providerArray" [value]="items.id">{{items.firstName + ' ' + items.lastName}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Form Type</mat-label>
              <mat-select formControlName="formType">
                <mat-option *ngFor="let items of fType" [value]="items.value">{{items.viewValue}}</mat-option>
              </mat-select>
              <mat-error *ngIf="pRegisterForm.controls.formType.errors?.required">
                This field is required !
              </mat-error>
            </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Patient Id</mat-label>
              <input matInput formControlName="patientId">
              <mat-error *ngIf="pRegisterForm.controls.patientId.errors?.required">
                This field is required !
              </mat-error>
            </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width app-checkbox-field">
              <input matInput formControlName="isChecked" disabled>
              <mat-checkbox
                matPrefix
                formControlName="isSubscriber"
                [checked]="pRegisterForm.controls.isSubscriber.value"
                (change)="setPatientAsSubscriber()"
                class="custom-checkbox">
              </mat-checkbox>
              <mat-label matSuffix class="custom-label">Subscriber ?</mat-label>
            </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Subscriber First Name</mat-label>
              <input matInput formControlName="subscriberFName">
            </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Subscriber Last Name</mat-label>
              <input matInput formControlName="subscriberLName">
            </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Subscriber DOB</mat-label>
              <input matInput formControlName="subscriberDOB">
            </mat-form-field>
          </div>

          <div class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Office ID</mat-label>
              <mat-select formControlName="officeId">
                <mat-option *ngFor="let type of OfficeType" [value]="type.id">{{type.name}}</mat-option>
              </mat-select>
              <mat-error *ngIf="pRegisterForm.controls.officeId.errors?.required">
                This field is required !
              </mat-error>
            </mat-form-field>
          </div>

          <div class="app-form-col" *ngIf="!this.isExternalUser">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Select Agent</mat-label>
              <mat-select formControlName="userId">
                <mat-option *ngFor="let agent of filterAgentArray" [value]="agent.id">
                  {{ agent.firstName }} {{ agent.lastName }}
                </mat-option>
              </mat-select>
              <!-- <mat-error *ngIf="pRegisterForm.controls.userId.errors?.required">
                This field is required !
              </mat-error> -->
            </mat-form-field>
          </div>

          <div *ngIf="!isExternalUser" class="app-form-col">
            <mat-form-field appearance="outline" class="app-full-width">
              <mat-label>Urgency ?</mat-label>
              <mat-select formControlName="urgency">
                <mat-option *ngFor="let items of urgencyArray" [value]="items.value">{{items.viewValue}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div *ngIf="patientId" class="app-form-col app-form-col-inline">
            <div class="app-inline-status" [ngClass]="status ? 'active' : 'inactive'">
              <span class="app-inline-label">Status :</span>
              {{ status ? 'Active' : 'Inactive' }}
              <label class="switch">
                <input type="checkbox" class="success" [checked]="this.status" (click)="changeStatus(this.status)">
                <span class="slider round"></span>
              </label>
            </div>
          </div>

          <div *ngIf="patientId" class="app-form-col app-form-col-inline">
              <div class="app-inline-action">

                  <span class="app-inline-label">
                      Re-evaluate :
                  </span>

                  <button
                      class="btn app-btn app-btn-primary app-btn-sm batch"
                      type="button"
                      (click)="runBatchJob()"
                      [disabled]="isReEvaluating">

                      <ng-container *ngIf="!isReEvaluating; else reEvaluatingTemplate">
                          Patient
                      </ng-container>

                      <ng-template #reEvaluatingTemplate>
                          <span
                              class="spinner-border spinner-border-sm mr-2"
                              role="status"
                              aria-hidden="true">
                          </span>
                          Re-evaluating...
                      </ng-template>

                  </button>

              </div>
          </div>
          
        </div>

        <section *ngIf="includesMedical" class="medical-insurance-section" formGroupName="medicalInsurance" aria-label="Medical insurance details">
          <div class="medical-insurance-header"><div><h2 class="medical-insurance-title">Medical Insurance</h2><p class="medical-insurance-subtitle">Medical coverage is maintained independently from Dental coverage.</p></div></div>
          <div class="medical-insurance-card">
            <div class="medical-insurance-grid">
              <mat-form-field appearance="outline">
                <mat-label>Insurance Type</mat-label>
                <mat-select formControlName="insuranceType" required>
                  <mat-option value="Primary">Primary</mat-option>
                  <mat-option value="Secondary">Secondary</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Medical Carrier</mat-label>
                <mat-select formControlName="payerId" required>
                  <mat-option *ngFor="let payer of payerArray" [value]="payer.id">
                    {{payer.name}} <span *ngIf="payer.payerIdCode">({{payer.payerIdCode}})</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Group Number</mat-label>
                <input matInput formControlName="groupNo">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Group Name</mat-label>
                <input matInput formControlName="groupName">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Plan Name</mat-label>
                <input matInput formControlName="planName" placeholder="NO_PLAN">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Insurance ID</mat-label>
                <input matInput formControlName="insuranceId">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Network Type</mat-label>
                <mat-select formControlName="networkType">
                  <mat-option value="In-Network">In-Network</mat-option>
                  <mat-option value="Out-Of-Network">Out-Of-Network</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Form Type</mat-label>
                <mat-select formControlName="formType">
                  <mat-option value="FULL FORM">Full Form</mat-option>
                  <mat-option value="SHORT FORM">Short Form</mat-option>
                  <mat-option value="ELIG CHECK">Eligibility Check</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Plan Type</mat-label>
                <mat-select formControlName="planType">
                  <mat-option value="PPO">PPO</mat-option>
                  <mat-option value="HMO">HMO</mat-option>
                  <mat-option value="EPO">EPO</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Claims Address</mat-label><input matInput formControlName="claimsAddress">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Pre-authorization Address</mat-label><input matInput formControlName="preAuthorizeAddress">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Coverage Plan</mat-label><input matInput formControlName="coveragePlan">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Employer Name</mat-label><input matInput formControlName="employerName">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Plan Creation</mat-label>
                <mat-select formControlName="planCreation">
                  <mat-option value="YES">Yes</mat-option>
                  <mat-option value="NO">No</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-checkbox formControlName="eligible">Eligible</mat-checkbox>
              <mat-checkbox formControlName="addOn">Add-on Insurance</mat-checkbox>
              <mat-checkbox formControlName="maxed">Maximum Reached</mat-checkbox>
            </div>
          </div>
        </section>

        <div class="app-form-actions">
          <button type="button"  (click)="onCancel()" class="btn app-btn app-btn-secondary">
            Back
          </button>

          <button *ngIf="!patientId"
                  class="btn app-btn app-btn-primary"
                  mat-raised-button
                  color="primary"
                  type="submit"
                  [disabled]="!pRegisterForm.valid">
            Register
          </button>

          <button *ngIf="patientId"
                  class="btn app-btn app-btn-primary"
                  mat-raised-button
                  color="primary"
                  type="submit">
            Update
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
